// ***************************
// Globally Cached Selectors
// ***************************

window.$ = $;
window.jQuery = jQuery;

// cached globals assigned in masterpage
window.containerWidth = 0;
window.currentDocWidth = 0;
window.currentWindowWidth = 0;
window.headStyle;

window.doColumnSizingKicker = window.doColumnSizingKicker || function() { };
window.trackScrollPositions = window.trackScrollPositions || function() { };
window.restoreScrollPositions = window.restoreScrollPositions || function() { };